import React from 'react';
import { useCSS } from '../../lib/hooks';
import { injectIntl } from 'react-intl';
import { i18nIntl, getRemotedbUrl } from '../../lib/ep';

import ModuleHeader from './ModuleHeader';
import ActionLink from '../builder/ActionLink';

const DefaultItem = ({ children, url, ...props }) => {
	if(children == undefined) return null;

	const selected = props?.selected ?? false;

	const is_enabled = true;
	let custom_class = [];
	if(selected) custom_class.push('cursor');
	if(!is_enabled) custom_class.push('is_not_enabled');

	return (
		<ActionLink
			_href={(url != undefined) ? ((url.indexOf('http') > -1) ? url : getRemotedbUrl(url)) : null}
			_class={{other:custom_class.join(" ")}}
			{...props}
		>
			{children}
		</ActionLink>
	)
};

const OwnerMenu = (props) => {
	const sections = props?.sections || [];
	if(sections.length == 0) return null;

	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	useCSS('comp/owner_menu.css');
	useCSS('comp/tabs.css');

	const is_builder = props?.is_builder ?? false;

	let nav_classes = ['is_menu'];
	if(is_builder) nav_classes.push('subsections_menu', 'main_bg');
	if(props._class != undefined) nav_classes.push(props._class);

	let section_classes = ['subsection_block'];
	if(props?.scrollable ?? false) section_classes.push('v_scrollable_tabs');

	return (
		<nav class={nav_classes.join(" ")} {...props.nav_props}>
			{sections.map((section, s) => {
				const items = section?.items ?? [];
				if(items.length == 0) return null;
				const section_title = section?.title ?? false;

				const enabled_sections = items.filter((item) => { return item?.enabled ?? true; });
				if(enabled_sections.length < 1) return null;

				return (
					<div key={`section_${s}`} class="navigation_actions">
						{(section_title !== false) && (
							<ModuleHeader
								_class={{other:'section_title in_top gui_not_bordered'}}
								autotranslate={false}
							>{i18n(section_title, 'ucfirst')}</ModuleHeader>
						)}

						<ul class={section_classes.join(" ")}>
							{items.map((item, i) => {
								const enabled = item?.enabled ?? true;
								if(!enabled) return null;

								const classes = ['tabbed_section', 'as_menu'];
								if(item.class != undefined) classes.push(item.class);

								if(item.custom != undefined) {
									return (
										<li key={`item_${i}`} id={item.id} class={classes.join(" ")}>
											{item.custom}
										</li>
									)
								}

								return (
									<li key={`item_${i}`} id={item.id} class={classes.join(" ")}>
										<DefaultItem
											key={`item_${i}`}
											{...item}
										/>
									</li>
								)
							})}
						</ul>
					</div>
				)
			})}
		</nav>
	)
};

export default injectIntl(OwnerMenu);